module.exports = __webpack_public_path__ + "img/DR.a3877fa6.png";